import { createAction, PrepareAction } from '@reduxjs/toolkit';

import reducer from './reducer';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

export const prepareFinalize:PrepareAction<{ time?: number, nextStep: SelfServiceSteps, shouldReset?: boolean }> = (nextStep, time, shouldReset) => ({
  payload: {
    time,
    nextStep,
    shouldReset,
  },
});

export const finalizeSelfService = createAction('SELF_SERVICE/FINALIZE', prepareFinalize);

export const { openFlowTypeModal, resetFlowType, setFlowType } = reducer.actions;
